module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp1_3.7c31b6ce.png";